// Globals
import { useTranslation } from 'react-i18next';

// Models
import { IAppraiserPrice } from '@/models/prices.model';

// Components
import { EditIcon, TrashIcon } from '@/icons';
import { Button } from '@/ui';
import {
  StyledButtonsWrapper,
  StyledCard,
  StyledContent,
  StyledContentWrap,
  StyledItem,
  StyledLabel,
  StyledName,
  StyledTitleWrapper,
  StyledValue,
  StyledWrapper,
} from './AppraiserCardStyles';

// Helpers
import { renderCurrency } from '@/utils';

type TAppraiserCardProps = {
  item: IAppraiserPrice;
  onDelete: (id: string) => void;
  onEdit: (item: IAppraiserPrice) => void;
};

const AppraiserCard = ({ item, onDelete, onEdit }: TAppraiserCardProps) => {
  const { t } = useTranslation(['prices', 'common']);
  const handleDelete = () => onDelete(item.PK);
  const handleEdit = () => onEdit(item);

  return (
    <StyledCard>
      <StyledWrapper>
        <StyledTitleWrapper>
          <StyledName>{item.name_no}</StyledName>
          <StyledLabel>({item.name_en})</StyledLabel>
        </StyledTitleWrapper>
        <StyledButtonsWrapper>
          <Button ghost type="dashed" icon={<EditIcon />} onClick={handleEdit} />
          <Button ghost type="dashed" icon={<TrashIcon />} danger onClick={handleDelete} />
        </StyledButtonsWrapper>
      </StyledWrapper>
      <StyledContentWrap>
        <StyledContent>
          <StyledItem>
            <StyledLabel>{t('label_price_from')}</StyledLabel>
            <StyledValue>{item.from_area ?? '-'}</StyledValue>
          </StyledItem>
          <StyledItem>
            <StyledLabel>{t('label_price_to')}</StyledLabel>
            <StyledValue>{item.to_area ?? '-'}</StyledValue>
          </StyledItem>
          <StyledItem>
            <StyledLabel>{t('label_settlement_price')}</StyledLabel>
            <StyledValue>{renderCurrency(item?.price)}</StyledValue>
          </StyledItem>
        </StyledContent>
        <StyledItem>
          <StyledLabel>{t('label_property_type')}</StyledLabel>
          <StyledValue>
            {item.property_type ? t(`property_type_${item.property_type}`, { ns: 'common' }) : '-'}
          </StyledValue>
        </StyledItem>
      </StyledContentWrap>

      <StyledItem>
        <StyledLabel>{t('label_price_description_en')}</StyledLabel>
        <StyledValue>
          <div dangerouslySetInnerHTML={{ __html: item.description_en ?? '-' }} />
        </StyledValue>
      </StyledItem>

      <StyledItem>
        <StyledLabel>{t('label_price_description_no')}</StyledLabel>
        <StyledValue>
          <div dangerouslySetInnerHTML={{ __html: item.description_no ?? '-' }} />
        </StyledValue>
      </StyledItem>
    </StyledCard>
  );
};

export default AppraiserCard;
